import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { getToken } from "../../utils/getToken";

export const useResetPasswordMutation = () => {
  const token = getToken();

  return useMutation({
    mutationFn: (email: string) =>
      axiosInstance
        .patch(
          "/admins/reset-password",
          { email: email },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => res.data),
    onSuccess: async (data) => {
      message.success(data?.message);
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
